import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

const prefersReduced = () =>
  typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;

/** True while the OS asks for reduced motion; updates live. */
export const useReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReduced);

  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return;
    const onChange = () => setReduced(media.matches);
    media.addEventListener?.("change", onChange);
    return () => media.removeEventListener?.("change", onChange);
  }, []);

  return reduced;
};

/** Duration for JS-driven transitions (MUI `timeout`, setTimeout staggers): 0 when reduced. */
export const motionMs = (ms: number) => (prefersReduced() ? 0 : ms);
